import MVerificationCodeModal from './MVerificationCodeModal'
import MModal from './MModal'
import MVerifyCodeInput from './m-verify-code-input'
import MMoneyInput from './m-money-input'
import PaymentChannelCard from './payment-channel-card'
import MethodCard from './method-card'
import GtcComponents from './gtcComponents'
import OutPlatformCopy from './out-platform-copy'
import GtcCopycard from './gtc-copycard'

export default {
  MVerificationCodeModal,
  MModal,
  ...MVerifyCodeInput,
  ...MMoneyInput,
  ...PaymentChannelCard,
  ...MethodCard,
  ...GtcComponents,
  ...OutPlatformCopy,
  ...GtcCopycard,
  authenticator: {
    google: {
      title: 'Google Authenticator',
      desc: 'Open Google Authenticator and enter the 6-digit code (refreshes every 30s).',
    },
    microsoft: {
      title: 'Microsoft Authenticator',
      desc: 'Open Microsoft Authenticator and enter the 6-digit code (refreshes every 30s).',
    },
    generic: {
      title: 'Authenticator App',
      desc: 'Open your authenticator app and enter the 6-digit code (refreshes every 30s).',
    },
    hint: {
      pass: 'Pass the verify',
      tip: 'If codes keep failing, ensure your phone time is auto-synced, or use another method.',
    },
  },
  security: {
    mfa: {
      andTitle: 'Two-step verification (must pass all)',
      orTitle: 'Two-step verification (choose  one)',
      passkey: {
        title: 'Passkey',
        // Fine-grained states and actions
        descIdle: 'Click “Start verification”, then complete in the system/browser prompt.',
        descRequesting: 'Requesting verification parameters…',
        descPrompting: 'Verification started. Please complete in the system/browser prompt.',
        descVerifying: 'Verifying credentials…',
        descError: 'Verification failed. Please retry or use another method.',
        ctaStart: 'Start verification',
        ctaRetry: 'Retry',
        errors: {
          notAllowed: 'Cancelled or timed out. Please try again.',
          abort: 'Verification aborted. Please retry or use another method.',
          security: 'Environment not secure. Check site protocol and domain.',
          invalidState: 'Credential state invalid. Check passkeys in account settings.',
          generic: 'Verification failed. Please retry or use another method.',
        },
        hint: {
          pass: 'Pass the verify',
          tip: 'If no prompt appears: ensure the page is foreground, popups not blocked, and device lock is enabled.',
        },
      },
      options: {
        sms_validate: 'SMS verification',
        email_validate: 'Email verification',
        app_validate: 'Authenticator App',
        biometric_validate: 'Passkey',
      },
      actions: {
        finishVerify: 'Finish',
        cancel: 'Cancel',
      },
      errors: {
        userCancelled: 'Cancelled by user',
        notPassed: 'Verification failed',
      },
      orchestrator: {
        missingUI: 'Missing MFA UI bridge: inject via MFAService.setUI(...) at app startup',
        invalidVerifier: 'Invalid verifier registered: missing verify()',
        unregistered: 'Unregistered verifier: {type}',
        needOnAnd: 'UI.onAnd not provided: AND step requires parallel verifiers in UI',
        needOnOr: 'UI.onOr not provided: OR/unknown step requires user choice in UI',
        notPassed: 'Verification not passed',
        prereqTitle: 'Tip',
        prereqMessages: {
          smsRequired: 'Please verify the phone number',
          appRequired: 'Please bind the Authenticator App',
          passkeyRequired: 'Please bind the Passkey',
          passkeyUnsupported:
            'Your current device or browser does not support Passkey. Please complete verification on a supported device/browser (such as iPhone/Safari or Chrome browser).',
          passkeyTypeMismatch:
            'Current environment requires: {envText}\nBut you are currently using: {curText}\nPlease switch to a matching device/browser, or bind the corresponding Passkey type and try again.',
          applePasskey: 'Apple Passkey',
          googlePasskey: 'Google Passkey',
          unspecified: 'Unspecified',
          sms_validate: 'Verify phone number',
          app_validate: 'Bind Authenticator App',
          biometric_validate: 'Bind the passkey',
          oneOfRequired: 'Please complete one of the following operations: {policy}',
        },
      },
    },
  },
  'h-verify-code-input': {
    'send-code': 'Send Code',
  },
  'email-verify-code-input': {
    label: 'Current Email',
    'send-code': 'Send Code',
    'resend-code': 'Resend ({time}s)',
    'wait-retry': 'Please wait {timeLeft} seconds to retry',
    'request-in-progress': 'Sending verification code...',
    'no-email': 'Please enter your email address',
    'no-api-url': 'API endpoint not configured',
    'send-success': 'Verification code sent, please check your email',
    'send-failed': 'Failed to send verification code, please try again',
    hint: {
      pass: 'Pass the verify',
      tip: 'If you did not receive the email, check spam or try again later.',
    },
  },
  'sms-verify-code-input': {
    label: 'Current Phone Number',
    'send-code': 'Send Code',
    'resend-code': 'Resend ({time}s)',
    'wait-retry': 'Please wait {timeLeft} seconds to retry',
    'request-in-progress': 'Sending verification code...',
    'no-api-url': 'API endpoint not configured',
    'send-success': 'Verification code sent',
    'send-failed': 'Failed to send verification code, please try again',
    hint: {
      pass: 'Pass the verify',
      tip: 'If you did not receive the SMS, check spam or try again later.',
    },
  },
  'password-input': {
    rules: {
      length: 'Length between 8 ~ 15 characters',
      'mixed-case': 'At least one uppercase and one lowercase letter',
      number: 'At least one number',
      'special-char': 'At least one special character',
    },
    validation: {
      'please-input-password': 'Please enter password',
    },
  },
  'trading-password-modal': {
    title: 'Change Trading Password',
    'new-password-label': 'New Trading Password',
    'email-verify-code': {
      label: 'Email Verification Code',
    },
    validation: {
      'please-input-new-password': 'Please enter new password',
      'please-input-confirm-password': 'Please confirm password',
      'password-mismatch': 'Passwords do not match',
    },
  },
  'limit-price-input': {
    unit: {
      pips: 'pips',
    },
  },
  numericInput: {
    errors: {
      negativeNotAllowed: 'Negative numbers are not allowed',
      lessThanMin: 'Value cannot be less than min',
      greaterThanMax: 'Value cannot be greater than max',
      inValid: 'Invalid number format',
      min: 'Value is too small',
      max: 'Value is too large',
      step: 'Value must be a multiple of step',
      precision: 'Precision is too large',
      required: 'Value is required',
      format: 'Invalid number format',
    },
  },
  'sltp-field': {
    price: 'Price',
    point: 'Point',
    numericInput: {
      errors: {
        min: 'Value must be at least {value}',
        max: 'Value must be at most {value}',
        nonNegative: 'Value must be non-negative',
      },
    },
  },
  'h-table-column-config': {
    title: 'Column Settings',
    reset: 'Reset',
    save: 'Save',
  },
  'support-center': {
    label: 'Support Center',
  },
  imageUpload: {
    'upload-selector-text': 'Upload Image',
    'edit-image-title': 'Edit Image',
    'no-file': 'No File',
    'file-size-exceeded': 'File size cannot exceed {maxSize}MB',
    'invalid-file-type': 'Invalid file type. Only JPG, PNG, GIF, BMP formats are supported',
    'max-count-exceeded': 'Maximum {maxCount} image(s) allowed',
  },
  fileUpload: {
    'upload-selector-text': 'Upload File',
    'upload-no-file': 'No File',
    'file-size-exceeded': 'File size cannot exceed {maxSize}MB',
    'file-type-not-allowed': '{fileName} type not allowed, only supports: {accept}',
    'upload-success': '{fileName} uploaded successfully',
    'upload-failed': '{fileName} upload failed: {error}',
    'invalid-response-format': 'Invalid response format',
    'compression-failed': '{fileName} compression failed, will upload original file',
  },
  PDFSigner: {
    tip: {
      emptyDescription: 'No file.',
    },
  },
  encryptModal: {
    cancelText: 'Cancel',
    okText: 'Confirm',
    tipMessage: 'Verify your account to ensure safe operations',
    encryptTip: 'All data is encrypted for security',
  },
  gtcModal: {
    cancelText: 'Cancel',
    okText: 'Confirm',
  },
  'gtc-input': {
    placeholder: 'Please input',
  },
  countrySelector: {
    search: 'Search',
    placeholder: 'Select country',
  },
  sendCodeButton: {
    'send-code': 'Send Code',
    'resend-code': 'Resend ({time}s)',
    'wait-retry': 'Please wait {timeLeft} seconds to retry',
    'request-in-progress': 'Sending verification code...',
    'no-api-url': 'API endpoint not configured',
    'send-success': 'Verification code sent',
    'send-failed': 'Failed to send verification code, please try again',
    'invalid-email': 'Please input valid email',
    'invalid-phone': 'Please input valid phone number. eg: +14155552671 +8613812345678）',
  },
  Stockholder: {
    title: 'Stockholder {index}',
    button: {
      add: 'Add Stockholder',
      delete: 'Delete',
    },
  },
  gtcEmpty: {
    'no-data': 'No Data',
  },
}
